export const MINIMUM_ORDER_TOTAL_GEL = 40;

export const meetsMinimumOrderTotal = (total) =>
    Number(total) >= MINIMUM_ORDER_TOTAL_GEL;

